import React from "react";
import Link from "next/link";
import Image from "next/image";

const CompanyOverview = ({ heading, companyData, feedbackLinks }) => {
  return (
    <div className="w-full max-w-screen-mxl mx-auto">
      {heading && (
        <h2 className="text-3xl sm:text-4xl font-bold mb-14 w-fit border-none mx-auto">
          {heading}
        </h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
        {companyData.map((item) => (
          <div key={item.id} className="flex justify-center gap-4 text-left">
            <div className="flex justify-center items-center text-4xl text-white bg-violet-500 w-[80px] h-[80px] rounded-full">
              {item.icon}
            </div>
            <div className="flex-1 flex flex-col gap-1">
              <span className="text-5xl sm:text-6xl font-bold text-black">
                {item.value}
              </span>
              <p className="text-md text-gray-900">{item.label}</p>
            </div>
          </div>
        ))}
      </div>
      {feedbackLinks && (
        <div className="flex justify-center items-center flex-wrap gap-12 mt-14 removeBg">
          {feedbackLinks.map((item, index) => (
            <Link key={index} href={item.url}>
              <Image
                src={require(`@assets/affiliates/${item.image}`)}
                alt={""}
                width={200}
                height={50}
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompanyOverview;
